import React from 'react';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../components/buttons/ButtonNavigation';
import SummaryEmployeeContractor from './SummaryEmployeeContractor';
import { STEPS_CONTRACTOR_EMPLOYEE_CREATE } from '../../Model/Models';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import Step2OtherDetails from './../../../Company/Employees/EnrollmentSteps/Step2OtherDetails';
import ManagerFields from '../ContractorCreateUpdateFlows/ManagerFields';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */
const ContractorEmployeeCreateWithDetails = ({
    user,
    setUser,
    steps,
    activeStep,
    setActiveStep,
    handleStepChange,
    emptyFields,
    isValidDocumentId,
    setIsValidDocumentId,
    isValidEmail,
    isValidPhoneNumber,
    isValidDob,
    setIsValidDob,
    handleEmailChange,
    handlePasswordChange,
    handlePhoneNumberChange,
    handleDateChange,
    userInfoStatusList,
    handleClearAll,
    handleValidateSteps,
    extraData,
    setExtraData,
    handleChange,
    handleClearExtraData,
    headersList,
    photoPicker,
    setPhotoPicker,
    FormHandler,
    extraDataEnabled,
}) => {
    return (
        <StepperTabs
            id={null}
            steps={steps}
            activeStep={activeStep}
            isStepOptional={() => {}}
            setActiveStep={setActiveStep}
            handleStepChange={handleStepChange}
        >
            <StepTab index={STEPS_CONTRACTOR_EMPLOYEE_CREATE.MANAGER_DETAILS} activeStep={activeStep} normalHeight>
                <>
                    <ManagerFields
                        title={'user_data'}
                        user={user}
                        setUser={setUser}
                        emptyFields={emptyFields}
                        isValidDocumentId={isValidDocumentId}
                        setIsValidDocumentId={setIsValidDocumentId}
                        isValidEmail={isValidEmail}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDob={isValidDob}
                        setIsValidDob={setIsValidDob}
                        handleEmailChange={handleEmailChange}
                        handlePasswordChange={handlePasswordChange}
                        handlePhoneNumberChange={handlePhoneNumberChange}
                        handleDateChange={handleDateChange}
                        statusList={userInfoStatusList}
                        handleClearAll={handleClearAll}
                    />
                    <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6 mb-60px'>
                        <ButtonNextStep
                            id='btn_cecwd_next_other_details'
                            text='next'
                            click={() => {
                                if (handleValidateSteps(0)) {
                                    setActiveStep((prev) => prev + 1);
                                }
                            }}
                        />
                    </div>
                </>
            </StepTab>
            <StepTab index={STEPS_CONTRACTOR_EMPLOYEE_CREATE.OTHER_DETAILS} activeStep={activeStep} normalHeight>
                <>
                    <Step2OtherDetails
                        showBtnClean={user?.id == null || user?.id === ''}
                        extraData={extraData}
                        onChange={handleChange}
                        setExtraData={setExtraData}
                        headersList={headersList}
                        handleClearExtraData={handleClearExtraData}
                    />

                  <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                        <ButtonPrevStep
                            id='btn_cecwd_back_details'
                            text='back'
                            click={() => setActiveStep((prev) => prev - 1)}
                        />
                        <ButtonNextStep
                            id='btn_cecwd_next_photo_profile'
                            text='next'
                            click={() => setActiveStep((prev) => prev + 1)}
                        />
                    </div>
                </>
            </StepTab>
            <StepTab index={STEPS_CONTRACTOR_EMPLOYEE_CREATE.ADD_PHOTO} activeStep={activeStep} normalHeight>
                <>
                    <CustomPhotoPicker
                        id='fp_cecwd_update_photo_profile'
                        photoPicker={photoPicker}
                        setPhotoPicker={setPhotoPicker}
                        actionModel={ACTION_MODEL.CREATE}
                        accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                        showBtnCamera
                        validateFace
                        showPreview
                        classWith={'content-center-w-400px mt-4'}
                        typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE}
                    />

                    <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                        <ButtonPrevStep
                            id='btn_cecwd_back_other_details'
                            text='back'
                            click={() => setActiveStep((prev) => prev - 1)}
                        />
                        <ButtonNextStep
                            id='btn_cecwd_next_summary'
                            text='next'
                            click={() => setActiveStep((prev) => prev + 1)}
                        />
                    </div>
                </>
            </StepTab>
            <StepTab index={STEPS_CONTRACTOR_EMPLOYEE_CREATE.SUMMARY} activeStep={activeStep} normalHeight>
                <>
                    <SummaryEmployeeContractor
                        user={user}
                        photoPicker={photoPicker}
                        extraDataEnabled={extraDataEnabled}
                        headersList={headersList}
                        extraData={extraData}
                    />

                    <div className='d-flex justify-content-between mt-3'>
                        <ButtonPrevStep
                            id='btn_cecwd_back_photo_profile'
                            text='back'
                            click={() => setActiveStep((prev) => prev - 1)}
                        />
                        <ButtonNextStep id='btn_cecwd_enroll' text='create' click={FormHandler} />
                    </div>
                </>
            </StepTab>
        </StepperTabs>
    );
};

export default ContractorEmployeeCreateWithDetails;
